module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.isLoading) ? _c('loading') : _c('div', [_c('p', [_vm._v("Standaard zijn alle onderstaande opdrachten beschikbaar voor de leerlingen.\n    U kunt tijd vrij maken voor eigen opdrachten door opdrachten hieronder uit te schakelen. Dit kan ook later aangepast worden.")]), _vm._l((_vm.terms), function(term) {
    return _c('div', {
      staticClass: "assignment-toggle__term"
    }, [_c('hr'), _c('h2', {
      staticClass: "assignment-toggle__term-title"
    }, [_vm._v(_vm._s(term.title))]), _vm._l((term.periods), function(period) {
      return _c('div', {
        staticClass: "assignment-toggle__period"
      }, [_c('p', {
        staticClass: "assignment-toggle__period-title tag",
        class: {
          'assignment-toggle__period-title--error': _vm.hasError(period)
        }
      }, [_vm._v(_vm._s(period.title))]), _vm._l((period.assignments), function(assignment) {
        return _c('div', {
          staticClass: "assignment-toggle",
          class: {
            'is-disabled': _vm.isOptional(assignment)
          }
        }, [_c('a', {
          staticClass: "assignment-toggle__link",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.toggleAssignment(assignment)
            }
          }
        }, [_c('img', {
          staticClass: "assignment-toggle__hero",
          attrs: {
            "src": assignment.image,
            "alt": assignment.title
          }
        }), _c('span', {
          staticClass: "assignment-icon",
          class: 'icon-' + assignment.type
        }), _c('h3', {
          staticClass: "assignment-toggle__title"
        }, [_vm._v(_vm._s(assignment.title))]), _c('p', {
          staticClass: "assignment-toggle__subtitle"
        }, [_vm._v(_vm._s(assignment.subtitle))]), _c('span', {
          staticClass: "time tag tag--timid"
        }, [_vm._v(_vm._s(assignment.time) + " minuten")])])])
      })], 2)
    })], 2)
  }), _c('primary-button', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    attrs: {
      "loading": _vm.isSaving
    },
    on: {
      "clicked": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1650add8","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/Assignments.vue
// module id = sK5L
// module chunks = 0 1